export const UrlsConstant = {
  URL_HOME: "https://comixtime.it/home.php",
  URL_RECOVER_PWD: "https://comixtime.it/rubrica/ripristino_password.php",
  URL_COMIC_WIKI: "https://wiki.comixtime.it/index.php?title=Albo",
  URL_SERIES_WIKI: "https://wiki.comixtime.it/index.php?title=Collana",
  URL_OFFICIAL_INFO: "https://wiki.comixtime.it/index.php?title=Dove_trovare_le_informazioni_ufficiali",
  URL_IMAGE: "https://fra1.digitaloceanspaces.com/comixtime/img/",
  URL_IMAGE_STAGE: "https://fra1.digitaloceanspaces.com/comixtime/stage/",
} as const
